import React, { startTransition } from 'react'
import { navigate } from 'gatsby'
import { ReactComponent as Login } from '@/assets/icons/login.svg'

import { Button } from '@/components/atoms/Button/Button'
import { getUrl } from '@/helpers/getUrl'
import { LogInProps } from './types'

function LogIn({ buttons }: LogInProps) {
  const handleClick = (url: Link) => {
    startTransition(() => {
      navigate(getUrl(url))
    })
  }

  return (
    <div
      className="flex items-center gap-16 justify-between w-full netbook:w-auto netbook:mx-auto netbook:ml-auto
  netbook:mr-0 whitespace-nowrap"
    >
      {buttons?.length > 0 &&
        buttons.map((button, index) => (
          <Button
            key={button._uid}
            {...button}
            variant={button.variant}
            className="w-full first:flex first:items-center first:gap-10 [&>svg>path]:transition [&:hover>svg>path]:!fill-white"
            onClick={() => handleClick(button.url)}
          >
            {index === 0 && <Login />}
            {button.text}
          </Button>
        ))}
    </div>
  )
}

export default LogIn
